module.exports = __webpack_public_path__ + "img/GBX.24775a4f.svg";